export default __webpack_public_path__ + "static/media/banner_default.dcc1cf2f.png";